/**
 * Export the root Spark application.
 */
module.exports = {
    el: '#spark-app',

    /**
     * Holds the timestamp for the last time we updated the API token.
     */
    lastRefreshedApiTokenAt: null,

    /**
     * The application's data.
     */
    data: {
        user: null,
        teams: [],
        currentTeam: null,

        loadingNotifications: false,
        notifications: null,
        notificationsPage: 1,
        hasNextNotificationsPage: false,

        supportForm: new SparkForm({
            from: '',
            subject: '',
            message: ''
        })
    },



    /**
     * The component has been created by Vue.
     */
    created() {
        // Initialize data from Spark.state if available
        this.syncDataFromSparkState();

        // Ensure teams are loaded even if they weren't present in initial state
        if (!this.teams || (Array.isArray(this.teams) && this.teams.length === 0)) {
            this.getTeams();
        }

        if (Spark.userId) {
            this.loadDataForAuthenticatedUser();
        }

        if (Spark.userId && Spark.usesApi) {
            this.refreshApiTokenEveryFewMinutes();
        }

        Bus.$on('updateUser', () => {
            this.getUser();
        });

        Bus.$on('updateUserData', () => {
            this.loadDataForAuthenticatedUser();
        });

        Bus.$on('updateTeams', () => {
            this.getTeams();
        });

        Bus.$on('updateCurrentTeam', () => {
            this.getCurrentTeam();
        });

        Bus.$on('showNotifications', () => {
            $('#modal-notifications').modal('show');

            this.markNotificationsAsRead();
        });

        Bus.$on('showSupportForm', () => {
            if (this.user) {
                this.supportForm.from = this.user.email;
            }

            $('#modal-support').modal('show');

            setTimeout(() => {
                $('#support-subject').focus();
            }, 500);
        });

        Bus.$on('loadMoreNotifications', function () {
            this.notificationsPage++;
            this.getNotifications();
        }.bind(this));
    },


    /**
     * Prepare the application.
     */
    mounted() {
        this.whenReady();
    },


    methods: {
        /**
         * Finish bootstrapping the application.
         */
        whenReady() {
            //
        },

        /**
         * Load the data for an authenticated user.
         * Only load notifications - user, teams, currentTeam are already in Spark.state
         */
        loadDataForAuthenticatedUser() {
            // Only load notifications - user, teams, currentTeam are already in Spark.state
            this.getNotifications();
        },


        /**
         * Refresh the current API token every few minutes.
         */
        refreshApiTokenEveryFewMinutes() {
            this.lastRefreshedApiTokenAt = moment();

            setInterval(() => {
                this.refreshApiToken();
            }, 240000);

            setInterval(() => {
                if (moment().diff(this.lastRefreshedApiTokenAt, 'minutes') >= 5) {
                    this.refreshApiToken();
                }
            }, 5000);
        },


        /**
         * Refresh the current API token.
         */
        refreshApiToken() {
            this.lastRefreshedApiTokenAt = moment();

            axios.put('/spark/token');
        },


        /*
         * Get the current user of the application.
         * This is called when user data needs to be refreshed (e.g., after profile updates)
         */
        getUser() {
            axios.get('/user/current')
                .then(response => {
                    this.$set(this, 'user', response.data);
                });
        },


        /**
         * Get the current team list.
         * This is called when teams data needs to be refreshed (e.g., after team creation/deletion)
         */
        getTeams() {
            if (!Spark?.state?.user) {
                return;
            }
            
            axios.get('/settings/'+Spark.teamsPrefix)
                .then(response => {
                    this.$set(this, 'teams', response.data);
                    this.$forceUpdate();
                })
                .catch(error => {
                    //
                });
        },


        /**
         * Get the current team.
         * This is called when current team data needs to be refreshed (e.g., after team switching)
         */
        getCurrentTeam() {
            axios.get(`/settings/${Spark.teamsPrefix}/current`)
                .then(response => {
                    this.$set(this, 'currentTeam', response.data);
                })
                .catch(response => {
                    //
                });
        },


        /**
         * Get the application notifications.
         */
        getNotifications() {
            this.loadingNotifications = true;

            axios.get('/notifications/recent?page=' + this.notificationsPage)
                .then(response => {
                    if (this.notificationsPage === 1) {
                        this.$set(this, 'notifications', response.data);
                    } else if (this.notifications && this.notifications.notifications) {
                        this.$set(
                            this.notifications,
                            'notifications',
                            this.notifications.notifications.concat(response.data.notifications)
                        );
                        this.$set(
                            this.notifications,
                            'notificationsHasNextPage',
                            response.data.notificationsHasNextPage
                        );
                    }

                    Bus.$emit('notificationsLoaded');
                })
                .finally(() => {
                    this.loadingNotifications = false;
                });
        },


        /**
         * Mark the current notifications as read.
         */
        markNotificationsAsRead() {
            if ( ! this.hasUnreadNotifications) {
                return;
            }

            axios.put('/notifications/read', {
                notifications: _.map(this.notifications.notifications, 'id')
            });

            _.each(this.notifications.notifications, notification => {
                notification.read = 1;
            });
        },


        /**
         * Send a customer support request.
         */
        sendSupportRequest() {
            Spark.post('/support/email', this.supportForm)
                .then(() => {
                    $('#modal-support').modal('hide');

                    this.showSupportRequestSuccessMessage();

                    this.supportForm.subject = '';
                    this.supportForm.message = '';
                });
        },


        /**
         * Show an alert informing the user their support request was sent.
         */
        showSupportRequestSuccessMessage() {
            // Swal.fire({
            //     title: __('Got It!'),
            //     text: __('We have received your message and will respond soon!'),
            //     icon: 'success',
            //     showConfirmButton: false,
            //     timer: 2000
            // });
            // [Nick] TODO: replace with another alert, Sweet Alert 2 was removed
        },

        /**
         * Sync data from Spark.state to local component state
         */
        syncDataFromSparkState() {
            if (Spark.state) {
                if (Spark.state.user) {
                    this.$set(this, 'user', Spark.state.user);
                }
                if (Spark.state.teams) {
                    this.$set(this, 'teams', Spark.state.teams);
                }
                if (Spark.state.currentTeam) {
                    this.$set(this, 'currentTeam', Spark.state.currentTeam);
                }
            }
        }
    },


    computed: {
        /**
         * The number of unread announcements.
         */
        unreadAnnouncementsCount() {
            if (this.notifications && this.notifications.announcements && this.user) {
                if (this.notifications.announcements.length && ! this.user.last_read_announcements_at) {
                    return this.notifications.announcements.length;
                }

                return _.filter(this.notifications.announcements, announcement => {
                    return moment.utc(this.user.last_read_announcements_at).isBefore(
                        moment.utc(announcement.created_at)
                    );
                }).length;
            }

            return 0;
        },


        /**
         * The number of unread notifications.
         */
        unreadNotificationsCount() {
            if (this.notifications) {
                return _.filter(this.notifications.notifications, notification => {
                    return ! notification.read;
                }).length;
            }

            return 0;
        },


        /**
         * Determine if the user has any unread notifications.
         */
        hasUnreadAnnouncements() {
            return this.unreadAnnouncementsCount > 0;
        },


        /**
         * Determine if the user has any unread notifications.
         */
        hasUnreadNotifications() {
            return this.unreadNotificationsCount > 0;
        }
    }
};
